<!--
 * @Description:标签管理页面
 * @Author: mdb
 * @Date: 2022-06-10 13:33:54
 * @LastEditTime: 2023-04-19 18:24:26
 * @LastEditors: mdb
-->
<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table
        serial
        :columns="columns"
        v-model:search="queryForm"
        @fetch="getList"
        ref="tableRef"
        :tableId="subdomain === 'fbu' ? 'DcCosFbuTagManage' : 'DcCosLbuTagManage'"
      >
        <template #search>
          <a-form :model="queryForm">
            <dc-form-item name="name" label="标签名称">
              <a-input v-model:value.trim="queryForm.name" :maxlength="100" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="parentName" label="上级标签">
              <a-input v-model:value.trim="queryForm.parentName" :maxlength="100" allowClear placeholder="请输入" />
            </dc-form-item>
            <dc-form-item name="type" label="类型">
              <a-select v-model:value="queryForm.type" :options="typeEnum" placeholder="请选择" allowClear />
            </dc-form-item>
            <dc-form-item name="status" label="状态">
              <a-select
                :fieldNames="{ label: 'name' }"
                v-model:value="queryForm.status"
                allowClear
                placeholder="请选择"
                :options="statusEnum"
              />
            </dc-form-item>
            <dc-form-item name="createTime" label="创建时间">
              <CosRangePicker v-model:startTime="queryForm.createTimeStart" v-model:endTime="queryForm.createTimeEnd" />
            </dc-form-item>
          </a-form>
        </template>

        <template #button>
          <a-button v-permission="permission.add" type="primary" @click="triggerAddOrEdit()">添加</a-button>
        </template>

        <template #bodyCell="{ column, record, text }">
          <template v-if="column.dataIndex === 'status'">
            <dc-status :enums="statusEnum" :value="text" />
          </template>
          <template v-if="column.dataIndex === 'type'">
            {{ ['', '静态标签'][text] }}
          </template>
          <template v-if="column.dataIndex === 'action'">
            <a-button v-permission="permission.edit" type="link" @click="triggerAddOrEdit(record.id)">编辑</a-button>
            <a-button v-permission="permission.del" type="link" @click="handleDelete(record)">删除</a-button>
            <a-button
              v-if="record.status === 2"
              v-permission="permission.enable"
              type="link"
              @click="handleStatus(record)"
              >启用</a-button
            >
            <a-button
              v-if="record.status === 1"
              v-permission="permission.disable"
              type="link"
              @click="handleStatus(record)"
              >停用</a-button
            >
          </template>
        </template>
      </cos-table>
    </dc-layout-content>
  </dc-layout-main>
</template>

<script setup lang="ts">
import { reactive, computed, ref, PropType } from 'vue'
import { useRouter } from 'vue-router'
import { message } from '@dc-platform/dc-components'
import CosRangePicker from '@/components/CosRangePicker/index'
import { tagsManageList, tagsManageModify, tagsManageDelete } from '@/api/marketing/marketingManage'
import Modal from '@/hooks/modalType'
import { MarketingManageParams, MarketingManageListItem } from '@/typings/api/marketingManage'
import type { SelectProps } from 'ant-design-vue'
const router = useRouter()

const props = defineProps({
  subdomain: {
    type: String as PropType<'fbu' | 'lbu'>,
    required: true
  },
  permission: {
    type: Object as PropType<{
      add: string
      edit: string
      del: string
      enable: string
      disable: string
    }>,
    required: true
  }
})

const statusEnum = [
  { name: '启用', value: 1, color: '#3FAC46' },
  { name: '停用', value: 2, color: '#DF443B' }
]
const typeEnum = ref<SelectProps['options']>([{ value: 1, label: '静态标签' }])

const tableRef = ref()
const queryForm = reactive<MarketingManageParams>({})

const columns = computed(() => [
  {
    title: '标签名称',
    dataIndex: 'name',
    cosType: 'link',
    path: `/${props.subdomain}/tagsManage/view`,
    query: ['id'],
    fixed: 'left'
  },
  { title: '上级标签', dataIndex: 'parentName' },
  { title: '类型', dataIndex: 'type' },
  { title: '备注', dataIndex: 'remark' },
  { title: '状态', dataIndex: 'status' },
  { title: '创建人', dataIndex: 'createByName' },
  { title: '创建时间', dataIndex: 'createTime', width: 200 },
  { title: '操作', dataIndex: 'action', width: 170, fixed: 'right' }
])
const getList = (queryForm: MarketingManageParams, callBack: (res: any) => void) => {
  tagsManageList(queryForm).then((res) => {
    callBack(res)
  })
}

// 新增编辑函数
const triggerAddOrEdit = (id?: number) => {
  if (id) {
    router.push({ path: `/${props.subdomain}/tagsManage/edit`, query: { id } })
  } else {
    router.push(`/${props.subdomain}/tagsManage/add`)
  }
}
const handleStatus = (row: MarketingManageListItem) => {
  const params = {
    id: row.id,
    status: row.status === 1 ? 2 : 1
  }
  tagsManageModify(params).then(() => {
    message.success(row.status === 1 ? '已停用' : '已启用')
    tableRef.value?.fetch()
  })
}
const handleDelete = (row: MarketingManageListItem) => {
  Modal.delete({
    name: row.name,
    onOk() {
      tagsManageDelete({ id: row.id }).then(() => {
        message.success('删除标签成功')
        tableRef.value?.delFetch()
      })
    }
  })
}
</script>
<script lang="ts">
export default { name: 'DcCosZbuTagsManage' }
</script>

<style scoped></style>
